import { useStore } from "zustand";
import appBarState, { IAppBarState } from "../state/appBarState";

export type UseAppBarStateReturn = [IAppBarState, typeof appBarState.setState];

const useAppBarState = (): UseAppBarStateReturn => {
    const state = useStore(appBarState);
    return [state, appBarState.setState];
};

export default useAppBarState;
